<template>
  <div class="page page-policy">
    <div class="page__wrap" data-animate="page-wrap">
      <header class="row-1 p-top-5" ref="text">
        <!-- Titolo  -->
        <h1 data-animate="header-title" class="title-m">
          {{ $t('bucket.privacyPolicy') }}
        </h1>
      </header>

      <div
        class="row-1 p-top-5 p-bot-3 text-m page-policy-text"
        data-animate="page-content"
      >
        <div v-html="policy" v-if="policy"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/editorial.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el, done)
      await tl.delay(0.5).play()
      done()
    },
    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

const { t, locale } = useI18n()

const code = locale.value === 'it' ? 16040860 : 25872740

const { data } = await useAsyncData(() =>
  $fetch(`https://www.iubenda.com/api/privacy-policy/${code}/no-markup`)
)

const policy = computed(() => {
  return data.value?.content?.replace(/<h1>.*?<\/h1>/g, '')
})

// Seo

useSeo({
  title: t('bucket.privacyPolicy'),
  meta: [
    {
      name: 'description',
      content: t('bucket.descriptionPrivacyPolicy'),
    },
  ],
})
</script>

<style></style>
